<template>
  <div>
    <TopBar :page="topBarData" @addBtnClick="addBtnClicked"/>
    <v-container fluid>
      <v-row>
        <v-col>
          <TicketsListTable :onPage="'tickets'" />
        </v-col>
      </v-row>
    </v-container>
    <TicketsListFilter :openFilter="openFilter" @closeDialog="openFilter=false;" />
  </div>
</template>

<script>
import TicketsListTable from "@/components/Tickets/TicketsListTable";
import TicketsListFilter from "@/components/Tickets/TicketsListFilter";
import TopBar from "@/components/Layout/TopBar";

export default {
  components: {
    TicketsListTable,
    TicketsListFilter,
    TopBar
  },
  
  data() {
    return {
      topBarData: {
        name: 'Tickets',
        type: 'tickets',
        showSearch: true,
        menu: false,
        breadcrumbs: [],
        additionalButtons: [
          {
            inner: 'filter',
            color: 'secondary',
            method: 'openFilter',
          }
        ],
        showBeehiveIcon: true,
        articleLink: 'tickets',
      },
      openFilter: false
    }
  },

  mounted () {
    if(this.$route.query.product_id!==undefined){
      this.topBarData.breadcrumbs = [
        {
          text: 'Tickets',
          disabled: false,
          href: '/tickets/',
        },
        {
          text: `Product - ${this.$route.query.product_id}`,
          disabled: true,
          href: '/tickets/',
        },
      ];
    }else{
      this.topBarData.breadcrumbs = [];
    }
  },

  methods: {
    addBtnClicked(btnName){
      switch(btnName){
        case 'openFilter':
          this.openFilter = true;
          break
      }
    },
  },
}
</script>

<style>

</style>
